export const LOCALIZED_SHORT_DATE_WITH_FULL_TIME = 'll LTS';

export const X_SCROLL_BASE_TRIGGER_VALUE = 300;
export const Y_SCROLL_TRIGGER_VALUE = 500;
